export default "__VITE_ASSET__Cnhlv_h9__"